import React, { useState, useEffect } from "react";
import { Table, Radio, Input, Typography, Button, message } from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";

const { Title } = Typography;
const { TextArea } = Input;

const questions = [
  {
    section: "Organizational Information Security",
    items: [
      { id: "1", text: "Do you have a member of your organization with dedicated information security duties?" },
      { id: "2", text: "Is a background check required for all employees accessing and handling the organization's data?" },
      { id: "3", text: "Does the organization have written information security policies?" },
      { id: "3.1", text: "If yes, please provide copies when responding to this assessment if possible" },
      { id: "4", text: "Does the organization have a written password policy that details the required structure of passwords?" },
      { id: "4.1", text: "How do you verify password strength?" },
      { id: "5", text: "Do all staff receive information security awareness training?" },
      { id: "6", text: "Does the organization employ a Data Classification and Retention Policy?" },
      { id: "7", text: "Does the organization have a formal change control process for IT changes?" },
      { id: "8", text: "Has the organization implemented an IT Governance framework such as ITIL, NIST, COBIT or ISO 27001?" },
      { id: "9", text: "Will your company be processing credit cards on behalf of the Up2date?" },
      { id: "9.1", text: "If yes, is your company PCI DSS compliant?" }
    ]
  },
  {
    section: "General Security",
    items: [
      { id: "10", text: "Is Endpoint Protection software installed on data processing servers and workstations?" },
      { id: "11", text: "Are system and security patches applied to workstations on a routine basis?" },
      { id: "12", text: "Are system and security patches applied to servers on a routine basis?" },
      { id: "12.1", text: "Are system and security patches tested prior to implementation in the production environment?" },
      { id: "13", text: "Do employees have a unique log-in ID with Phishing-Resistent MFA when accessing data?" },
      { id: "14", text: "Does the organization have security measures in place for data protection?" },
      { id: "14.1", text: "If yes, please describe in comments" },
      { id: "15", text: "Is access restricted to systems containing sensitive data?" },
      { id: "15.1", text: "If yes, what controls or are currently in place to restrict access?" },
      { id: "16", text: "Is physical access to data processing equipment (servers and network equipment) restricted?" },
      { id: "16.1", text: "If yes, what controls are in place?" },
      { id: "17", text: "Is there a process for secure disposal of both IT equipment, media and customer data?" },
      { id: "17.1", text: "If yes, please describe in the comments section" },
      { id: "18", text: "Does the organization have a formal log management and retention policy and process?" },
      { id: "18.1", text: "If yes, please describe the scope and length in the comments section" }
    ]
  },
  {
    section: "Network Security",
    items: [
      { id: "19", text: "Are network boundaries protected by firewalls?" },
      { id: "20", text: "Is regular vulnerability scanning performed?" },
      { id: "21", text: "Are Intrusion Detection Systems (IDS) or Intrusion Prevention Systems (IPS) used by your organization?" },
      { id: "21.1", text: "If yes, please describe in the comments section" },
      { id: "22", text: "Are employees required to use a VPN when accessing the organization's systems from all remote locations?" },
      { id: "23", text: "Is wireless access allowed in your organization?" },
      { id: "23.1", text: "If yes, please describe how it is protected in the comments section" }
    ]
  },
  {
    section: "Systems Security",
    items: [
      { id: "24", text: "Are computer systems (servers) backed up according to a regular schedule?" },
      { id: "24.1", text: "Has the back-up and recovery process been verified?" },
      { id: "24.2", text: "Does the organization store backups offsite?" },
      { id: "24.3", text: "Does the organization encrypt its backups?" },
      { id: "25", text: "Does the organization replicate data to locations outside of the United States?" },
      { id: "26", text: "Does the organization outsource its data storage?" },
      { id: "26.1", text: "If yes, to whom is the data outsourced?" },
      { id: "27", text: "Is there formal control of access to System Administrator privileges?" },
      { id: "27.1", text: "If a shared tenant is used for SaaS, IaaS or PaaS, please describe security measrues to separate access" },
      { id: "28", text: "Are servers configured to capture who accessed a system and what changes were made?" },
      { id: "28.1", text: "If no, in case of a security breach, how do you determine who accessed the system and what changes were made?" }
    ]
  },
  {
    section: "Business Continuity / Disaster Recovery",
    items: [
      { id: "29", text: "Does the organization have disaster recovery plans for data processing facilities?" },
      { id: "29.1", text: "Is the disaster recovery plan extend to and organization wide Business Continuity Plans?" },
      { id: "30", text: "Are computer rooms protected against fire and flood?" },
      { id: "31", text: "Does the organization have a 'Hot' recovery site?" }
    ]
  },
  {
    section: "Incident Response",
    items: [
      { id: "32", text: "If an information security breach involving the Court's data occurred, would the the Court be notified of the breach?" },
      { id: "32.1", text: "If yes, how soon would the Court be notified?" },
      { id: "33", text: "Does the organization have a formal Incident Response plan?" },
      { id: "33.1", text: "If yes, do you perform regular tabletop exercises?" },
      { id: "34", text: "Has the organization experienced an information security breach in the past three (3) years?" },
      { id: "34.1", text: "If so, please document what information was lost and what was the recovery process in the comments section?" },
      { id: "34.2", text: "If so, please document how the clients were notified and how quickly in the comments section?" }
    ]
  },
  {
    section: "Auditing / Client Reporting",
    items: [
      { id: "35", text: "Does the organization receive an SSAE-16 SOC Report?" },
      { id: "35.1", text: "If so, please document which type of SOC report is being obtained in the comments section.  Please provide a copy of the latest SOC report." },
      { id: "35.2", text: "If not, do you perform a regular penetration testing and and can you provide a remediation attestation?" },
      { id: "35.3", text: "If not, does the organization allow clients the right to audit their systems and controls?" }
    ]
  },
  {
    section: "Application Development Security",
    items: [
      { id: "36", text: "Does your organization utilize a Secure SDLC process?" },
      { id: "36.1", text: "If yes, please provide a detailed process in the comments section (include any threat modelling processes and and code scanning activities)" },
      { id: "36.2", text: "If yes, do you conduct regular vulnerability testing or employ a bug bounty program?" },
      { id: "37", text: "Does the organization use contractors or third parties to develop its software?" },
      { id: "37.1", text: "Describe how the organization ensures its security policies are maintained by the third parties" }
    ]
  },
  {
    section: "Data Privacy",
    items: [
      { id: "38", text: "Does the organization have a global privacy and data protection policy/ies? (please submit a copy)" },
      { id: "39", text: "Does the organization provide privacy and personal data handling training to employees who have access to PII?" },
      { id: "40", text: "If processing or storing California residents' data, does the organization adhere to the CCPA?" },
      { id: "40.1", text: "Does the contract/master agreement provide for a privacy amendement for processing activities?" }
    ]
  }
];

function RiskAssessment() {
  const { projectId } = useParams();
  const [answers, setAnswers] = useState({});

  const handleChange = (id, field, value) => {
    setAnswers((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const data = [];
  questions.forEach((section) => {
    data.push({ key: section.section, isSection: true, section: section.section });

    section.items.forEach((q) => {
      data.push({
        key: q.id,
        id: q.id,
        question: q.text,
        isSection: false,
      });
    });
  });

  // ✅ GET DATA
  useEffect(() => {
    const fetchRisk = async () => {
      try {
        const res = await axios.get(`https://rhrmapi.up2dateinc.com/api/risk/${projectId}`);

        if (res.data?.data?.responses) {
          const formatted = {};
          res.data.data.responses.forEach((r) => {
            formatted[r.id] = {
              answer: r.answer,
              comment: r.comment,
            };
          });
          setAnswers(formatted);
        }
      } catch (err) {
        console.error(err);
      }
    };

    if (projectId) fetchRisk();
  }, [projectId]);

  const columns = [
    {
      title: "No",
      render: (_, record) => (record.isSection ? "" : record.id),
      width: 80,
    },
    {
      title: "Question",
      render: (_, record) =>
        record.isSection ? <b style={{ fontSize: "16px" }}>{record.section}</b> : record.question,
    },
    {
      title: "Answer",
      render: (_, record) =>
        record.isSection ? null : (
          <Radio.Group
            value={answers[record.id]?.answer}
            onChange={(e) => handleChange(record.id, "answer", e.target.value)}
            style={{ display: "flex", gap: "10px" }} // 🔥 THIS LINE FIXES IT
          >
            <Radio value="Yes">Yes</Radio>
            <Radio value="No">No</Radio>
          </Radio.Group>
        ),
    },
    {
      title: "Comments",
      render: (_, record) =>
        record.isSection ? null : (
          <TextArea
            rows={2}
            value={answers[record.id]?.comment}
            onChange={(e) => handleChange(record.id, "comment", e.target.value)}
          />
        ),
    },
  ];

  // ✅ POST DATA
  const handleSubmit = async () => {
    const responses = data
      .filter((d) => !d.isSection)
      .map((q) => ({
        id: q.id,
        question: q.question,
        answer: answers[q.id]?.answer || "",
        comment: answers[q.id]?.comment || "",
      }));

    try {
      await axios.post("https://rhrmapi.up2dateinc.com/api/risk/save", {
        projectId,
        responses,
      });

      message.success("Risk Assessment Submitted");
    } catch (err) {
      console.error(err);
      message.error("Failed to submit");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={3}>Risk Assessment</Title>

      <Table columns={columns} dataSource={data} pagination={false} bordered />

      <div style={{ marginTop: 20, textAlign: "right" }}>
        <Button type="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </div>
  );
}

export default RiskAssessment;